import React, { useState, useEffect } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Button, Select, message, Typography, Tag } from "antd";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import RenewalBulkUpdate from "../BookingForm/components/modalContent/RenewalBulkUpdate";
import Grid from "../../atoms/Grid";
import { useDispatch, useSelector } from "react-redux";

import { getContactList, setFilters } from "./ducks/actions";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../atoms/Popup";
import DragAndDropList from "../../atoms/Grid/gridColumnSort";

import dayjs from "dayjs";

import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterRenewal } from "../App/SearchFilters/ducks/actions";

import { getPendingRenewals } from "./ducks/services";
import { findLeaseStatus } from "../BookingForm/components/utils";
import { PendingRenewals } from "../BookingForm/components/modalContent";
import LoaderTsx from "../Loader.tsx";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { useContractsSearch } from "./hooks";
import { contractsCol, contractsColumn } from "./contractsColumn";
import { getGridSettings } from "../../../utils/globalService";
import { getOrgByID } from "../../modules/Maintenance/Tickets/ducks/actions";
import { useGetOrganization } from "../../../api/v1";
import { useGridReset } from "../../../hooks/useGridReset";

const { Title } = Typography;

const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 220,
};

const dropDown = [
  { id: 2, name: "Renewal Form", status: "" },
  { id: 3, name: "Send To Tenant", status: "" },
  { id: 4, name: "Cancel", status: "#FB7171" },
];
const dropDown1 = [{ id: 2, name: "Renewal Form", status: "" }];
const dropDown2 = [{ id: 2, name: "View Confirmed Form", status: "" }];
const dropDown3 = [{ id: 4, name: "View Approved Form", status: "" }];

const Contracts = (props) => {
  const dispatch: any = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState(false);
  const renewalFilters = useSelector((state: any) => state.contracts.renewalFilters);
  const { searchHistory } = useSearchHistory(setFilterRenewal);
  const [selectedSearchBy, setSelectedSearchBy] = useState(renewalFilters?.searchBy || "unitCode");
  const [searchValue, setSearchValue] = useState(renewalFilters?.search ?? "");
  const contractApi = useSelector((state: any) => state.contracts.contractList);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);
  const [searchKey, setSearchKeys] = useState(searchByOptions);
  const { selectOptions, handleSearch, handleChangeSearchBy } = useContractsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });
  const { organization: organizationDetail } = useGetOrganization();

  const isAgp = JSON.parse(window.localStorage.getItem("login-response"))?.isAgp;

  const nonAgpFilterKeys = [
    { label: "To Review", value: "to_review" }, // removed as per feedbacks from abbas
    { label: "Sent for Approval", value: "sent_for_approval" },
    { label: "Ready to Send", value: "ready_to_send" },
  ];
  const optionsAgp = [
    { label: "Sent to tenant", value: "sent" },
    { label: "Renewal Declined", value: "renewal_declined" },
    { label: "Show All", value: "all" },
  ];
  const optionsForStatus = isAgp === "yes" ? optionsAgp : [...nonAgpFilterKeys, ...optionsAgp];

  const [filterOptions, setFilterOptions] = useState([
    {
      name: "filter",
      label: "Filter",
      initialValue: renewalFilters?.filter || 150,
      title: "1",
      options: [
        { label: "Next 150 days", value: 150 },
        { label: "Next 120 days", value: 120 },
        { label: "Next 90 days", value: 90 },
        { label: "Next 60 days", value: 60 },
        { label: "Next 30 days", value: 30 },
        { label: "Expired", value: "expired" },
        { label: "Custom", value: "custom" },
      ],
    },
    {
      name: "status",
      label: "Status",
      initialValue: renewalFilters?.filterStatus || "sent",
      title: "2",
      options: optionsForStatus,
    },
  ]);
  const [filter, setFilter] = useState(filterOptions[0].initialValue);
  const [filterStatus, setStatusFilter] = useState(filterOptions[1].initialValue);
  const [trigger, setTrigger] = useState(0);
  const [selectedPropertyAdmin, setPropertyAdmin] = useState("All");
  const [downloadBulkUpdate, setDownloadBulkUpdate] = useState(false);
  const [uploadBulkUpdate, setUploadBulkUpdate] = useState(false);
  const [uploadBulkOption, setUploadBulkOptions] = useState(0);
  const [renewalDateFrom, setRenewalDateFrom] = useState(dayjs().format("YYYY-MM-DD"));
  const [renewalDateTo, setRenewalDateTo] = useState(dayjs().add(90, "day").format("YYYY-MM-DD"));
  const [contractColumns, setContractColumns] = useState(() => [...contractsCol(filterStatus)]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const organization = useSelector((state: any) => state.tickets.orgData);

  const MoreAction = (row) => {
    const navigate: any = useNavigate();
    const { Text } = Typography;

    const onChangeHanldler = async (e) => {
      if (e === "Cancel") {
      } else if (e === "Add Unit") {
      } else if (e === "Download booking form") {
      } else if (e === "View Confirmed Form") {
        navigate(`/renewals/form/${row.data.leaseId}`);
      } else if (e === "View Approved Form") {
        navigate(`/renewals/form/${row.data.leaseId}`);
      } else if (e === "Renewal Form") {
        if (row?.data.leaseStatus === "active" && row?.data.renewalStatus === "active") {
          navigate(`/viewbookingform/${row.data.leaseId}/renewalTorenewal`, {
            state: { renewal: true, renewalTorenewal: true },
          });
        } else {
          navigate(`/viewbookingform/${row.data.leaseId}`, {
            state: { renewal: true, renewalTorenewal: false },
          });
        }
      }
    };

    return (
      <Select
        onChange={onChangeHanldler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        allowClear
      >
        <>
          {row.data.leaseStatus === "created" &&
            dropDown.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus !== "created" &&
            row.data.leaseStatus !== "booking_confirmed" &&
            row.data.leaseStatus !== "booking_approved" &&
            dropDown1.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_confirmed" &&
            dropDown2.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
          {row.data.leaseStatus === "booking_approved" &&
            dropDown3.map((value, key) => (
              <React.Fragment key={key}>
                <Select.Option value={value.name}>
                  <Text style={{ color: `${value.status}` }}>{value.name}</Text>
                </Select.Option>
              </React.Fragment>
            ))}
        </>
      </Select>
    );
  };

  const setRenewalStatus = (data) => {
    //  that statement for creating renewal from renwal
    if (data.leaseStatus === "active" && data.renewalStatus === "active") {
      return findLeaseStatus["to_review"];
    } else if (
      data?.renewalStatus ||
      (data.leaseStatus && data.leaseStatus === "active"
        ? "to_review"
        : data.leaseStatus !== "active" && data?.leaseStatus)
    ) {
      return findLeaseStatus[
        data?.renewalStatus ||
          (data.leaseStatus && data.leaseStatus === "active"
            ? "to_review"
            : data.leaseStatus !== "active" && data?.leaseStatus)
      ];
    }
  };

  const handlePagination = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    const params = { renewalDate: filter, renewalStatus: filterStatus };
    setIsLoading(true);
    dispatch(getContactList(pageSize, page, searchValue, selectedSearchBy, params, null, setIsLoading));
  };
  const { resetGrid, setGridReset } = useGridReset();

  useEffect(() => {
    const buildLeaseColumnsWithKyc = (org) => {
      const kycFields = [...(org?.commercialKycForm || []), ...(org?.residentialKycForm || [])].filter(
        (field, index, self) => index === self.findIndex((f) => f.name === field.name),
      );

      const dynamicKycCols = kycFields.map((field, index) => ({
        id: 50 + index,
        headerName: field.label,
        field: `kycDetails.${field.name}`,
        checked: false,
        hide: true,
      }));

      const mergedLeaseCols = [...contractsCol(filterStatus), ...dynamicKycCols];
      getGridConfig(mergedLeaseCols);
      setContractColumns(mergedLeaseCols);
    };

    const init = async () => {
      const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

      if (isOrgEmpty) {
        const orgData = localStorage?.getItem("login-response");
        const orgId = orgData ? JSON.parse(orgData) : null;
        if (orgId) {
          await dispatch(getOrgByID(orgId?.orgId));
        }
      } else {
        buildLeaseColumnsWithKyc(organization);
      }
    };

    init();
  }, [organization, resetGrid]);

  const getGridConfig = async (columns) => {
    let result = await getGridSettings("contracts", columns, resetGrid);
    if (result?.length > 0) {
      setContractColumns(result);
      setGridReset(false);
    }
  };

  useEffect(() => {
    _getPendingRenewals();
  }, []);

  useEffect(() => {
    if (renewalFilters?.searchBy) {
      const setArray = searchKey.map((item) => {
        let val = null;
        if (item.value === renewalFilters?.searchBy) {
          val = { ...item, default: true };
        } else {
          val = { ...item, default: false };
        }
        return val;
      });
      setSearchKeys(setArray);
    }
  }, [renewalFilters, renewalFilters?.searchBy]);

  useEffect(() => {
    if (filter === "custom") {
      const diffDays = dayjs(renewalDateTo).diff(dayjs(renewalDateFrom), "day");
      if (diffDays > 90) {
        alert("Date range cannot be more than 90 days.");
        return;
      }
    }

    if (
      renewalFilters?.search != searchValue ||
      renewalFilters?.searchBy != selectedSearchBy ||
      renewalFilters?.filter != filter ||
      renewalFilters?.filterStatus != filterStatus
    )
      dispatch(setFilters({ searchValue, selectedSearchBy, filter, filterStatus, currentPage }));

    const params = {
      renewalDate: filter,
      renewalStatus: filterStatus,
      ...(filter === "custom" ? { renewalDateFrom } : {}),
      ...(filter === "custom" ? { renewalDateTo } : {}),
    };

    if (exportData) {
      let checkedColumns = contractColumns
        .filter((col) => col.checked && col.headerName !== "Actions")
        .map((col) => col.headerName)
        .join(", ");
      params["columns"] = checkedColumns;
      params["exportData"] = exportData;
      params["totalCount"] = contractApi?.totalCount;
    }

    if (downloadBulkUpdate) {
      params["exportData"] = true;
      params["bulkRenewal"] = downloadBulkUpdate;
      params["totalCount"] = contractApi?.totalCount;
    }

    setCurrentPage(1);
    setIsLoading(true);
    dispatch(
      getContactList(
        limit,
        1,
        searchValue,
        selectedSearchBy,
        params,
        setExportData,
        setIsLoading,
        setDownloadBulkUpdate,
        setVisible,
      ),
    );
  }, [
    searchValue,
    filter,
    renewalDateFrom,
    renewalDateTo,
    filterStatus,
    exportData,
    downloadBulkUpdate,
    selectedPropertyAdmin,
  ]);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0];
    if (searchKey.length > 0)
      searchKey.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  function handleFilterChange(selected, name) {
    const isStartDate = name === "hasSelectedStartDate";
    const isEndDate = name === "hasSelectedEndDate";
    const isCustomFilter = selected?.value === "custom" && name === "filter";
    const isExpired = selected?.value === "expired";
    const isFilterWithKey = typeof selected?.key === "number";

    if (isCustomFilter) {
      setFilter("custom");
      return;
    }

    if (isStartDate) {
      setRenewalDateFrom(dayjs(selected).format("YYYY-MM-DD"));
      setFilter("custom");
      return;
    }

    if (isEndDate) {
      setRenewalDateTo(dayjs(selected).format("YYYY-MM-DD"));
      setFilter("custom");
      return;
    }

    if (isFilterWithKey) {
      setFilter(selected.value);
      return;
    }

    if (isExpired) {
      setFilter(selected.value);
      return;
    }

    if (!isCustomFilter) {
      setStatusFilter(selected.value);
    }
  }

  const [pendingRenewals, setPendingRenewals]: any = useState({});

  const _getPendingRenewals = async () => {
    try {
      const response = await getPendingRenewals();
      if (response.data?.result?.data.length > 0) setPendingRenewals(response.data?.result);
    } catch (e) {
      console.log({ e });
    }
  };

  const popup = [
    {
      title: (
        <Title level={3} className="mb-0">
          Renewal Approval Request(s)
        </Title>
      ),
      content: <PendingRenewals renewals={pendingRenewals?.data} />,
      width: "80%",
    },
    {
      title: (
        <Title level={3} className="m-0">
          {uploadBulkOption === 0 ? "Bulk Update" : "Upload Renwal details through excel file"}
        </Title>
      ),
      content: (
        <RenewalBulkUpdate
          setVisible={setVisible}
          filterStatus={filterStatus}
          uploadBulkOption={uploadBulkOption}
          setUploadBulkOptions={setUploadBulkOptions}
          setDownloadBulkUpdate={setDownloadBulkUpdate}
          setUploadBulkUpdate={setUploadBulkUpdate}
          downloadBulkUpdate={downloadBulkUpdate}
          uploadBulkUpdate={uploadBulkUpdate}
        />
      ),
      width: 650,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger]?.title,
    content: popup[trigger]?.content,
    width: popup[trigger]?.width,
    onCancel: () => setVisible(false),
  };

  const filterData = (data: Array<any> = []) => {
    const dataCopy = [...data];

    if (dataCopy.length > 0) {
      for (let key in dataCopy) {
        if (
          (dataCopy[key].leaseType?.toLowerCase() === "renewal" || dataCopy[key].leaseType?.toLowerCase() === "new") &&
          dataCopy[key].leaseStatus === "active"
        ) {
          const leaseTerms = {
            ...dataCopy[key].leaseTerms,
            ...{
              leaseStartDate: dayjs(dataCopy[key].leaseTerms.leaseEndDate).add(1, "day").toISOString(),
              leaseEndDate: dayjs(dataCopy[key].leaseTerms.leaseEndDate).add(1, "year").toISOString(),
            },
          };

          dataCopy[key]["leaseTerms"] = {
            ...dataCopy[key]["leaseTerms"],
            ...leaseTerms,
          };
        }
      }
    }

    return dataCopy;
  };

  //  for export data and send in email

  const exportAction = () => {
    setExportData(true);
  };

  const modalPopuphandel = (trigerType) => {
    setTrigger(trigerType);
    setVisible(true);
    setUploadBulkOptions(0);
    setDownloadBulkUpdate(false);
  };

  return (
    <DashboardLayout load={false}>
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <SectionHeaderV2
                noBorder={true}
                heading="Upcoming Renewals"
                propertyAdminOptions={true}
                total={contractApi?.totalCount ?? 0}
                onSearch={handleSearch}
                onChangeSearchBy={handleChangeSearchBy}
                defaultSearch={searchValue}
                searchByOptions={searchByOptions}
                selectOptions={selectOptions}
                viewOption={filterOptions}
                justifiedItems={true}
                justifyEnd={true}
                downloadAction={exportAction}
                handleView={handleFilterChange}
                bulkUpdate={
                  (organizationDetail?.enableBulkRenewalUpdate && filterStatus === "to_review") ||
                  filterStatus === "sent_for_approval"
                }
                modalPopuphandel={modalPopuphandel}
                headTopLeftText={
                  pendingRenewals?.totalCount ? (
                    <Button danger type="text" onClick={() => modalPopuphandel(0)}>
                      <InfoCircleOutlined /> {pendingRenewals?.totalCount} pending requests
                    </Button>
                  ) : null
                }
              />
            </Col>
            <Col span={23}>
              <Pagination
                className="ag-property-text-pagination"
                total={contractApi?.totalCount ?? 0}
                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Renewals`}
                pageSize={contractApi?.perPage ?? 50}
                defaultCurrent={1}
                current={currentPage || renewalFilters?.currentPage}
                onChange={handlePagination}
              />
            </Col>
            <Col span={1}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <DragAndDropList
                  columns={contractColumns}
                  setModifiedColumns={setContractColumns}
                  changePicker={setDetectColumnChanges}
                  detectColumnChanges={detectColumnChanges}
                  screenName="contracts"
                  filterStatus={filterStatus}
                  setGridReset={setGridReset}
                />
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]} justify="end">
                <Col span={24}>
                  <Card bordered={false} className="ag-nospace-body">
                    {isLoading ? (
                      <LoaderTsx />
                    ) : (
                      <Grid
                        columns={contractsColumn(contractColumns, filterStatus, setRenewalStatus, MoreAction)}
                        pagination={false}
                        defaultSettings={gridProps}
                        noRowlabel="Contract"
                        fullPage={true}
                        data={filterData(contractApi?.data) ?? []}
                      />
                    )}
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Popup {...popupProps} />
    </DashboardLayout>
  );
};

export default Contracts;
